import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Grid } from '@material-ui/core'
import InputLabel from '@material-ui/core/InputLabel'
import { useSelector } from 'react-redux'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import { ParameterField } from './parameter-field'
import { AddItemButtons } from '../../../../../../conventions-collectives/themes/add-item-buttons'

export function FunctionDataPopperContent({
  nom,
  className,
  handleChange,
  functionData,
  currentTags,
  classes,
  currentType,
  excludeFonctions = [],
  line,
  setAnchorEl,
  fonctionParams,
  setFonctionParams,
}) {
  const [tmpFunctionName, setTmpFunctionName] = useState(() => '')
  const [tmpParamValues, setTmpParamValues] = useState()

  useEffect(() => {
    setTmpFunctionName(fonctionParams ? fonctionParams.fonction : '')
    setTmpParamValues(fonctionParams ? fonctionParams.params : '')
  }, [fonctionParams])

  const fonctions = useSelector(state => state.fonctionModule.fonctions)

  const innerHandleChange = (value, field) => {
    if (field === 'nomFonction') {
    }
  }
  const anyMatch = useCallback(tag => currentTags.includes(tag), [currentTags])

  const filtredFonctions = useMemo(
    () =>
      currentType
        ? fonctions.filter(f => !excludeFonctions.includes(f.nom) && f.type === currentType).map(f => f.nom)
        : fonctions.filter(f => !excludeFonctions.includes(f.nom) && f.tags.some(anyMatch)).map(f => f.nom),
    [fonctions, anyMatch, currentType]
  )

  //setTmpFunctionName({...tmpFunctionName, nomFonction : value})
  if (tmpFunctionName) console.log('param => ', fonctions.find(f => f.nom === tmpFunctionName).paramList)

  console.log('filtredFonctions=', filtredFonctions)
  console.log('tmpFunctionName=', tmpFunctionName)

  const paramList = useMemo(() => !!tmpFunctionName && fonctions.find(f => f.nom === tmpFunctionName).paramList, [
    tmpFunctionName,
    fonctions,
  ])

  const setParamValue = (paramName, paramValue) => {
    const newParamValues = tmpParamValues ? { ...tmpParamValues } : {}
    newParamValues[paramName] = paramValue
    setTmpParamValues(newParamValues)
    console.log(newParamValues)
  }

  const saveDisabled = useMemo(() => {
    console.log('saveDisabled', tmpParamValues)
    return (
      !tmpParamValues ||
      paramList.some(p => {
        console.log('param => ', p.parametre.nom)
        console.log(' tmpParamValues[p] === undefined', tmpParamValues[p.parametre.nom] === undefined)
        console.log(' tmpParamValues[p] === null', tmpParamValues[p.parametre.nom] === null)
        return tmpParamValues[p.parametre.nom] === undefined || tmpParamValues[p.parametre.nom] === null
      })
    )
  }, [paramList, tmpParamValues])

  const handleSaveFonction = () => {
    setFonctionParams({ fonction: tmpFunctionName, params: tmpParamValues })
  }

  return (
    <Grid witem xs={12}>
      <Grid container direction="column">
        <Grid>
          <InputLabel id="funciton_name_label">Fonction</InputLabel>
          <Autocomplete
            value={tmpFunctionName}
            data-test="double_composant"
            options={filtredFonctions}
            getOptionLabel={f => f}
            style={{ width: '100%' }}
            onChange={(e, value) => {
              setTmpFunctionName(value)
            }}
            renderInput={params => {
              return <TextField {...params} label="Selectionner input" />
            }}
          />
        </Grid>
        {!!tmpFunctionName &&
          paramList.map(param => (
            <Grid key={param.parametre.nom} container>
              <ParameterField
                param={param}
                classes={classes}
                excludeFonctions={[...excludeFonctions, tmpFunctionName]}
                line={line}
                setParamValue={setParamValue}
                paramValue={tmpParamValues ? tmpParamValues[param.parametre.nom] : null}
              />
            </Grid>
          ))}
      </Grid>
      <Grid container direction="row" justify="flex-end">
        <Grid container direction="row" justify="flex-end">
          <AddItemButtons
            onSave={handleSaveFonction}
            onCancel={() => setAnchorEl(null)}
            showList={true}
            cancelDataTest={'ANNULER ELEMENT DE REFERENCE'}
            saveDataTest={'AJOUTER ELEMENT DE REFERENCE'}
            isSaveDisabled={saveDisabled}
            addDataTest={'data-test-butouns-pop'}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
